import api from '../api';

let apiUrl = 'contentstreams';
let apiUrlSpecial = 'contentstreams/special';
let apiUrlFavourites = 'contentstreams/favourites';
let apiUrlSpecialReports = 'contentstreams/special-reports';

const state = {
    data: {
        data: [],
        meta: [],
        recentContentstreamsByKey: {} // keyed by "productId_typeId"
    }
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },

    recentContentstream: ({ commit, state }, config) => {
        const productId = config.params.product_id;
        const typeId = config.params.contentstream_type_id[0];
        const cacheKey = `${productId}_${typeId}`;

        return (
            state.data.recentContentstreamsByKey[cacheKey] ||
            api
                .get(`/api/v1/${apiUrl}`, config)
                .then((response) => {
                    commit('setRecentContentstreamsByKey', { cacheKey, data: response.data || response });
                    return response.data || response;
                })
                .catch((error) => {
                    console.error(error);
                    return Promise.reject(error);
                })
        );
    },

    specials: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrlSpecial}`, config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    specialReports: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrlSpecialReports}`, config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    favourites: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrlFavourites}`, config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, response) {
        if (response.config.params?.page) {
            state.data.meta = response.data.meta;
            state.data.links = response.data.links;
            state.data.data.push(...response.data.data);
        } else {
            state.data = response.data;
        }
    },

    setRecentContentstreamsByKey(state, { cacheKey, data }) {
        state.data.recentContentstreamsByKey[cacheKey] = data.data;
    },

    setByKey(state, response) {
        let key = response.config.params.key;

        if (state.data.hasOwnProperty(key)) {
            state.data[key].meta = response.data.meta;
            state.data[key].links = response.data.links;

            // only append if append_to_list is true
            response.data.data.length
                ? response.config.params?.page && response.config.params?.append_to_list
                    ? state.data[key].data.push(...response.data.data)
                    : (state.data[key].data = response.data.data)
                : (state.data[key].data = []);
        } else {
            state.data[key] = response.data;
        }
    },

    setById(state, data) {
        let key = data.data.key;
        let id = data.data.id;

        if (state.data.hasOwnProperty(key)) {
            let index = state.data[key].data.findIndex((contentstream) => contentstream.id === id);
            state.data[key].data[index] = data.data;
        } else {
            let index = state.data.data.findIndex((contentstream) => contentstream.id == id);
            state.data.data[index] = data.data;
        }
    }
};

const getters = {
    all: (state) => {
        return state.data;
    },

    getRecentContentstreamByKey: (state) => (productId, typeId) => {
        const cacheKey = `${productId}_${typeId}`;
        return state.data.recentContentstreamsByKey[cacheKey] || null;
    },

    getById: (state) => (id) => {
        return state.data.find((item) => item.id === id);
    },

    getBySlug: (state) => (slug) => {
        return state.data.find((item) => item.slug === slug);
    },

    getMeta: (state) => {
        return state.meta;
    },

    getByKey: (state) => (key) => {
        if (state.data && state.data.hasOwnProperty(key)) {
            return state.data[key];
        } else {
            return {
                data: null,
                meta: null,
                links: null
            };
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
